import { createContext } from "react"
import type { ErrorMessage } from "src/types/ErrorMessage"

export interface ErrorHandlerContextProps {
	error?: ErrorMessage
	setError: (value: ErrorMessage | undefined) => void
}

export const ErrorHandlerContext = createContext<ErrorHandlerContextProps | undefined>(undefined)
